<template>
  <div class="container">
    <h3>Thank you - You Have Signed Out</h3>
    <br>
    <b-button @click="goLogin()">Log In</b-button>
  </div>
</template>

<script>
export default {
  name: 'cateringSignOut',
  mounted () {
    localStorage.removeItem('x-access-token')
    localStorage.removeItem('lastUpdateId') // force download of new config, regardless
  },
  methods: {
    goLogin () {
      this.$router.push({ name: 'caterinLogin' })
    }
  }
}
</script>
<style lang="scss" >
  .page-header {
    img {
      margin-top: 3em;
    }
  }
</style>
